import BarGraphRoot, { Props } from './BarGraph'

export default function BarGraph(props: Props) {
  return <BarGraphRoot {...props} />
}

export type { LegendItemProps } from './BarGraph'
